import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CKEditor from 'ckeditor4-react';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import axios from 'axios';
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";

	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			tab_name:'',
			title:'',
			description:'',
			content:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			image_name: [],
			image_preview: [],
			image:[],
			icon_preview : '',
			image_fileExtension:[],
			allImgArray : [],
			apply_on_maintab : false,
			apply_on_innertab : false,
			content_type : '',

			priority: '',
			selLinkOption:'',
			selLinkValue:'',
			selLinkFunc:'',
			selLinkLabel:'',
			selUserTypeOption:'',
			selUserTypeValue:'',
			selUserTypeLabel:'',
			selAccessTypeOption:'',
			selAccessTypeValue:'',
			selAccessTypeLabel:'',
			accessType:'ai',
			loggedSt:'Both',		
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);



    }
	  
	handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
   	};
   	handleOptionChange = (optVal, type) => {
		if(type === 'linkOption'){
			this.setState({	selLinkOption:optVal })
			this.setState({  selLinkLabel : optVal.label, selLinkValue : optVal.value });
		}
		else if(type === 'userTypeOption'){
			this.setState({	selUserTypeOption:optVal })
			this.setState({  selUserTypeLabel : optVal.label, selUserTypeValue : optVal.value });
		}
		else if(type === 'accessTypeOption'){	
			this.setState({	selAccessTypeOption:optVal })
			this.setState({  selAccessTypeLabel : optVal.label, selAccessTypeValue : optVal.value });
		}	
   	};

   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });

		if(name === 'apply_on_maintab'){
			this.setState({apply_on_maintab: !this.state.apply_on_maintab});
		} 
		if(name === 'apply_on_innertab'){
			  this.setState({apply_on_innertab: !this.state.apply_on_innertab});
		  } 	

  }

  validateForm() {
	//const {admin_company_name,admin_fname} = this.state;
	const {tab_name,title , apply_on_maintab , apply_on_innertab , button_text , content_type, accessType, selLinkValue, selUserTypeValue, selAccessTypeValue}  = this.state;
	var description = localStorage.getItem("tab_content");
	let errors = {};
	  let formIsValid = true;
	
	if (!tab_name) {
		formIsValid = false;
		$('.errortab_name').html('<span class="errorspan">Please fill the field</span>');
	}else if(tab_name){
		$('.errortab_name').html('');
	}
	
	// if (!title) {
	// 	formIsValid = false;
	// 	$('.errortab_title').html('<span class="errorspan">Please fill the field</span>');
	// }else if(tab_name){
	// 	$('.errortab_title').html('');
	// }

	// if(accessType == 'mainTab'){
	// 	if (!description) {
	// 		formIsValid = false;
	// 		$('.errordescription').html('<span class="errorspan">Please fill the field</span>');
	// 	}else if(description){
	// 		$('.errordescription').html('');
	// 	}

	// 	if(!apply_on_maintab && !apply_on_innertab){
	// 		formIsValid = false;
	// 		$('.errorapplyon').html('<span class="errorspan">Please select atleast one option</span>');
	// 	}else{
	// 		$('.errorapplyon').html('');
	// 	}
	
	// 	if (!button_text) {
	// 		formIsValid = false;
	// 		$('.errorbuttontext').html('<span class="errorspan">Please fill the field</span>');
	// 	}else if(description){
	// 		$('.errorbuttontext').html('');
	// 	}
	
	// 	if (!content_type) {
	// 		formIsValid = false;
	// 		$('.error_contenttype').html('<span class="errorspan">Please select atleast one option</span>');
	// 	}else if(description){
	// 		$('.error_contenttype').html('');
	// 	}
	// }
	// else if(accessType == 'ai'){
		if (!selLinkValue) {
			formIsValid = false;
			$('.errorselSubmenuValue').html('<span class="errorspan">Please fill the field</span>');
		}else if(selLinkValue){
			$('.errorselSubmenuValue').html('');
		}
		if (!selUserTypeValue) {
			formIsValid = false;
			$('.errorselUserTypeValue').html('<span class="errorspan">Please fill the field</span>');
		}else if(selUserTypeValue){
			$('.errorselUserTypeValue').html('');
		}
		if (!selAccessTypeValue) {
			formIsValid = false;
			$('.errorselAccessTypeValue').html('<span class="errorspan">Please fill the field</span>');
		}else if(selAccessTypeValue){
			$('.errorselAccessTypeValue').html('');
		}
	//}

	

	this.setState({
		errors: errors
	});
	return formIsValid;
}

  handleSubmit = () => {
	if(this.validateForm()){ 
	const formdata = this.state;
	var qs = require('qs');
	var status = '';

	if(formdata.selectedvalue === ''){
	status =formdata.selectedOption.value;
	}else{
	status = formdata.selectedvalue;
	}

	var postObject ={
		admin_id: localStorage.getItem('admin_id'),
		name : formdata.tab_name,
		title : formdata.tab_name,
		//title : formdata.title,
		// description: localStorage.getItem("tab_content"),
		// content: formdata.content,
		status: status,
		// apply_on_maintab: formdata.apply_on_maintab,
		// apply_on_innertab: formdata.apply_on_innertab,
		// button_text: formdata.button_text,
		// content_type :  formdata.content_type,

		accessType : formdata.selAccessTypeValue,
		loggedSt : formdata.selUserTypeValue,
		linkTo : formdata.selLinkValue,
		priority: formdata.priority,
	}
	

	let formData = new FormData();
	for(let k in postObject) {
		formData.append(k, postObject[k]);
	}

	var imgdata = formdata.allImgArray;
	for (var i in imgdata) {
		formData.append('images[]',imgdata[i])
	}


	var icondata = formdata.icon;
	formData.append('file',icondata)

	axios.post(apiUrl+"tabmanagement/add",formData).then(res => {
		if(res.data.status === "success"){
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						setTimeout(
						function() {
							$('.success_message').html(this.props.history.push('/tabmanagement'));
						}
						.bind(this),
						3000
						);
						localStorage.removeItem('tab_content')
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				
				setTimeout(
				function() {
					$('.success_message').html('');
				}
				.bind(this),
				3000
				);
			}
		});
	}
		
	}

	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			icon_name: file.name,
			icon_preview: reader.result,
			icon: file,
			icon_fileExtension:extension,
			
		  });
		};
		reader.readAsDataURL(file);
		
	  } 


	  onChangeMultipleHandler= e => {
		this.fileObj = [];
		this.fileNameArray = this.state.image_name;
		this.fileArray = this.state.image;
		this.extensionArray = this.state.image_fileExtension;
		this.image_preview = this.state.image_preview;
		this.allImgArray = this.state.allImgArray;
		this.fileObj.push(e.target.files);
		for (let i = 0; i < this.fileObj[0].length; i++) {
			this.fileNameArray.push(this.fileObj[0][i].name)
			this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
			this.allImgArray.push(this.fileObj[0][i])
			this.extensionArray.push(this.fileObj[0][i].name.split('.').pop());
			
		}
		
		this.setState({
			image_name: this.fileNameArray,
			image_preview: this.image_preview,
			image: this.fileArray,
			image_fileExtension:this.extensionArray,
			
		  });
		
	  }
	  
	removeImagebyindex = (indexvalue) => {
		var list = this.state.image;
		var allImgArray = this.state.allImgArray;
		
		this.imageArray = [];
		this.fileArray = [];
		list.splice(indexvalue, 1);
		allImgArray.splice(indexvalue,1)

	
		this.setState({ image: list , allImgArray : allImgArray })
		
	}

	onEditorChange( evt ) {
    	// console.log(evt.editor.getData())
    	// var callfunc = this;
    	// setTimeout(function () {
		// callfunc.setState( {
        //     terms_and_condition: evt.editor.getData()
        // } );
		// }, 1000);
		localStorage.setItem('tab_content',evt.editor.getData())
     
    }

	render() {

		const {selectedOption} = this.state;
		var imgThumblist ;
		let indexlength =  this.state.image.length;
		if(this.state.image.length > 0){
			imgThumblist =  this.state.image.map((url,index) => (
				<li className="thumb" key={indexlength+index}  >
					<span><img src={url}  alt="..." /></span>
					<a href="javascript:void(0);" onClick={this.removeImagebyindex.bind(this,index)}>X</a>
				</li>
			));
		}
		var	preview = (this.state.icon_preview) ? 
		<img className="img_class" src={this.state.icon_preview} alt="" /> :'';

		return (
			<div className="wrapper"> 
		
				<Header />
				<MenuSidebar currentpage="tabmanagement" />  

				<div id="location-error"></div>
				<div className="content">	
					<div className="content-wrapper">
						<div class="content-wrapper-before"></div>
						<div className="form-wrapper leaa-admin-head card">
							<div className="success_message"></div>
							<div className="title">
								<h4>Add Tab</h4>	
								<a className="" href='/tabmanagement'><span class="close">X</span></a>	
							</div>
							<form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
								<div className="form-row">
									<div className="form-left">
										<div className="form-group">
											<label>Tab Name<span class="required" style={{ color: "red" }} > * </span> : </label>
											<input type="text" name="tab_name" onChange={this.handleInputChange} className="form-control" value={this.state.tab_name}/>
											<div className="errortab_name"></div>
										</div>
										
										<div className="form-group" style={{ marginTop: '20px' }}>
											<label>User Access :</label>

											{/* <input onChange={this.handleInputChange} type="radio" name="loggedSt" value="Guest" checked={(this.state.loggedSt == "Guest" ? "checked" : "" )}/>
											Guest
											<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Logged In" checked={(this.state.loggedSt == "Logged In" ? "checked" : "" )}/>
											Logged In
											<input onChange={this.handleInputChange} type="radio"  name="loggedSt" value="Both" checked={(this.state.loggedSt == "Both" ? "checked" : "" )}/>
											Both								 */}
											<Select 
												name="User Type"
												value={this.state.selUserTypeOption? this.state.selUserTypeOption:{ value: '', label: 'Select'}}
												options={lang.common.tab_login_type} 
												isSearchable = {false}
												//onChange={this.handleOptionChange('userTypeOption')}
												onChange={(optVal) => this.handleOptionChange(optVal, 'userTypeOption')}

											/>
											<div className="errorselUserTypeValue"></div>
										</div>
										<div className="form-group">
											<label>Priority: </label>
											<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
											<div className="errorpriority"></div>
										</div>

										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
												name="status"
												value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
												options={lang.common.status_option} 
												isSearchable = {false}
												onChange={this.handleChange}
											/>
										</div> 
									</div>
										
									<div className="form-right">

										{/* <div className="form-group">
											<label>Title<span class="required" style={{ color: "red" }} > * </span> : </label>
											<input type="text" name="title" onChange={this.handleInputChange} className="form-control" value={this.state.title}/>
											<div className="errortab_name"></div>
										</div> */}
										<div className="form-group">
											<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
												name="Link to"
												value={this.state.selLinkOption? this.state.selLinkOption:{ value: '', label: 'Select'}}
												options={lang.common.sidebar_ai_options} 
												isSearchable = {false}
												//onChange={this.handleOptionChange('linkOption')}
											  onChange={(optVal) => this.handleOptionChange(optVal, 'linkOption')}

											/>
											<div className="errorselSubmenuValue"></div>
										</div> 
										<div className="form-group z-index-999" style={{ marginTop: '20px' }}>										
											<label>Access Type :</label>
											{/* <input onChange={this.handleInputChange} type="radio" name="accessType" value="mainTab" checked={(this.state.accessType == "mainTab" ? "checked" : "" )}/>
											Main Tab
											<input onChange={this.handleInputChange} type="radio"  name="accessType" value="ai" checked={(this.state.accessType == "ai" ? "checked" : "" )}/>
											AI Widget */}
											<Select 
												name="accessType"
												value={this.state.selAccessTypeOption? this.state.selAccessTypeOption:{ value: '', label: 'Select'}}
												options={lang.common.tab_access_type} 
												isSearchable = {false}
												//onChange={this.handleOptionChange('accessTypeOption')}
												onChange={(optVal) => this.handleOptionChange(optVal, 'accessTypeOption')}
											/>
											<div className="errorselAccessTypeValue"></div>
										</div> 
										
										<div className="form-group">
											<label>Icon (jpeg,jpg,png,svg)</label>
											<div className="choose-file">
											{this.state.isHidden && <div className="image_success"></div>}
											<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
											</div>
											{preview}
											{/* {image_preview?<a href="javascript:void(0);">X</a>:''} */}
											<div className="errorimage"></div>  
										</div>
									</div>	
								</div>		
								<div className="btn-group export">	
									<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >Submit</button>
								</div>
							</form>
						</div>
							
					</div>	
				</div>
					
			</div>
		);
	}
}


export default (withRouter(Add));